function inspirations() {
  $('.fancybox-inspiration').fancybox({
    touch: false,
  })

  $('.inspiration-popin .prev-btn').click(function() {
    let id = parseInt($(this).closest('.inspiration-popin').attr('data-id'));
    id -= 1;
    $.fancybox.close();
    $.fancybox.open({
      src: '#hidden-content-' + id,
    });
  });

  $('.inspiration-popin .next-btn').click(function() {
    let id = parseInt($(this).closest('.inspiration-popin').attr('data-id'));
    id += 1;
    $.fancybox.close();
    $.fancybox.open({
      src: '#hidden-content-' + id,
      touch: false,
    });
  });

  $('.pulse-icon .icon-wrap').click(function() {
    $(this).closest('.inspiration-tooltip').toggleClass('active');
  });
}

export { inspirations };